// P:\0PJ\synforge\frontend\lib\api\billing.ts v2 2026.08.26 - added getStripeConfig
import { api } from "./core"

export const billingAPI = {
  myTokens: () => api.get("/billing/tokens/"),
  getPaymentMethods:    () => api.get("/billing/payment-methods/"),
  addPaymentMethod:     (data: { brand: string; last4: string; exp_month: number; exp_year: number; cardholder_name?: string; country?: string; address?: string }) =>
    api.post("/billing/payment-methods/", data),
  deletePaymentMethod:  (id: string) => api.delete(`/billing/payment-methods/${id}/`),
  setDefaultPaymentMethod: (id: string) => api.post(`/billing/payment-methods/${id}/set-default/`),
  listPlans:  () => api.get("/billing/plans/"),
  myPlan:     () => api.get("/billing/my-plan/"),
  changePlan: (plan_key: string) => api.post("/billing/change-plan/", { plan_key }),
  getCharges:     () => api.get("/billing/charges/"),
  getPricing: () => api.get("/billing/pricing/"),
  getStripeConfig: () => api.get("/billing/stripe-config/"),
  getUsageSummary: () => api.get("/billing/usage-summary/"),
  getSessionDetail: (sessionId: string) => api.get(`/billing/session-detail/${sessionId}/`),
  createSetupIntent: () => api.post("/billing/setup-intent/"),
  confirmPaymentMethod: (paymentMethodId: string, customerId: string) =>
    api.post("/billing/confirm-payment-method/", { payment_method_id: paymentMethodId, customer_id: customerId }),
  rechargeTokens: (usdAmount: number, paymentMethodId?: string) =>
    api.post("/billing/recharge/", { usd_amount: usdAmount, payment_method_id: paymentMethodId }),
}